// Copyright (c) 2017 Deere & Company

export const rgaListSortOptions = [
    {
        displayName: 'Analyst ID',
        path: ['analystId']
    },
    {
        displayName: 'Part Return',
        path: ['rgaNumber']
    },
    {
        displayName: 'Dealer Code',
        path: ['rgaDealer']
    },
    {
        displayName: 'Claim',
        path: ['warrantyClaimNumber']
    },
    {
        displayName: 'Part Return Sub Type',
        path: ['rgaSubType']
    },
    {
        displayName: 'Pin',
        path: ['machineSerialNumber']
    },
    {
        displayName: 'Engine Serial Number',
        path: ['engineSerialNumber']
    },
    {
        displayName: 'Status',
        path: ['rgaStatus']
    },
    {
        displayName: 'Requested Date',
        path: ['requestDate']
    }
];



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/helpers/rga-list-sort-options.js